/***********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
2/6/18
Updated: 7.6.22
Harvest View: Table and report view for harvest module
***********************************************************/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchFieldsByLoc, fetchBlocksByField } from '../../../actions';
import { fetchAllMechHarvest, selectField, setReportOptions, selectReportType,
  fetchReport, selectNewReport } from '../../../actions/harvest_actions';
import { dynamicSort, dynamicReverseSort } from '../../../utils';
import HarvestReportForm from './harvest_report_form';
import MechHarvestTable from '../mechHarvest_table';
import HarvestReportView from './harvest_report_view';



class HarvestView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      harvest: this.props.mechHarvest,
      reverseSort: false
    }
    this.sortBy = this.sortBy.bind(this);
  }
  componentDidMount() {
    this.props.fetchAllMechHarvest();
  }
  componentWillReceiveProps(newProps) {
    if (newProps.mechHarvest) this.setState({ harvest: newProps.mechHarvest });
  }
  sortBy(id) {
    if (!id) return;
    let _id = id.split('-');
    if (this.state.reverseSort) this.setState({ reverseSort: !this.state.reverseSort }, () => {
      this.setState({ harvest: this.state.harvest.sort(dynamicReverseSort(_id[1])) })
    });
    this.setState({ harvest: this.state.harvest.sort(dynamicSort(_id[1])), reverseSort: !this.state.reverseSort });
  }
  render() {
    return (
      <div className="row">
      { !this.props.reportOpts.reportRunning ?
        <div>
          <div className={"col s12 m4 l3 xl3"}>
            <div className="card">
              <div className="harvest-form-card">
                <HarvestReportForm equipmentNo={this.props.equipmentNo} employees={this.props.employees} email={this.props.email}
                  fields={this.props.fields} blocks={this.props.blocks} fetchFieldsByLoc={this.props.fetchFieldsByLoc}
                  fetchBlocksByField={this.props.fetchBlocksByField} selectField={this.props.selectField}
                  disabled={this.props.disabled} setReportOptions={this.props.setReportOptions}
                  selectReportType={this.props.selectReportType} fetchReport={this.props.fetchReport}
                />
              </div>
            </div>
          </div>
          <div className={"col s12 m8 l9 xl9"}>
            <div className="card harvest-scrollable">
              <div className="harvest-form-card">
                <MechHarvestTable harvest={this.state.harvest} totals={false} onClick={this.sortBy} />
              </div>
            </div>
          </div>
        </div>
        :/* Report is running */
          <HarvestReportView query={this.props.query} selectNewReport={this.props.selectNewReport} options={this.props.options} />
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    blocks: state.harvest.blocks,
    disabled: state.harvest.report.disabled,
    eid: state.auth.user.guid,
    email: state.auth.user.email,
    employees: state.harvest.employees.all,
    equipmentNo: state.harvest.equipmentNo,
    fields: state.harvest.fields,
    mechHarvest: state.harvest.harvest.mech.displaying,
    query: state.harvest.report.query,
    reportOpts: state.harvest.report.reportOpts,
    options: state.harvest.report.options,
    seasons: state.harvest.seasons
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchAllMechHarvest,
    fetchFieldsByLoc,
    fetchBlocksByField,
    fetchReport,
    selectField,
    selectNewReport,
    selectReportType,
    setReportOptions
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(HarvestView);




/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/view/harvest_view.jsx